import type { ModuleNav } from '@saas/ui';

export const PROJECT_ADMIN_ROLES = ['owner', 'admin'];
/** 案件を読める人 = read / write / manage のどれか（write できるものは読め、manage できるものは書ける） */
export const PROJECT_READ = [
  'project.project.read.own',
  'project.project.read.team',
  'project.project.read.all',
  'project.project.write.own',
  'project.project.write.team',
  'project.project.write.all',
  'project.project.manage.own',
  'project.project.manage.team',
  'project.project.manage.all',
];
export const PROJECT_WRITE = ['project.project.write.own', 'project.project.write.team', 'project.project.write.all', 'project.project.manage.own', 'project.project.manage.team', 'project.project.manage.all'];
export const PROJECT_MANAGE = ['project.project.manage.own', 'project.project.manage.team', 'project.project.manage.all'];

export const projectNav: ModuleNav = {
  module: 'project',
  items: [
    { label: '案件', to: '/project', icon: 'home_repair_service', end: true, permission: PROJECT_READ, description: '受注後の案件・進捗・原価・粗利' },
    { label: '新しい案件', to: '/project/new', icon: 'add', permission: PROJECT_WRITE, description: '受注した仕事を案件にする' },
    { label: '工数入力', to: '/project/timesheets', icon: 'schedule', permission: ['project.timesheet.write'], description: '週の表で入力する' },
    { label: '案件アラート', to: '/project/alerts', icon: 'warning', permission: PROJECT_READ, description: '契約なし着工・金額の不一致・予算超過・変更契約の未登録' },
    { label: '原価の取込', to: '/project/costs/import', icon: 'upload', permission: ['project.cost.write'], description: '会計ソフトの CSV から仕入・外注費を取り込む' },
  ],
  admin: [],
};
